import _t from 'i18n!nls/academic-integrity';

export const MessageTypes = {
  COACH: 'coach',
  LEARNER: 'learner',
  LOADING: 'loading',
} as const;

export type MessageType = (typeof MessageTypes)[keyof typeof MessageTypes];

export const FlagStatus = {
  INCOMPLETE: 'INCOMPLETE',
  INTEGRITY_ISSUE_FOUND: 'INTEGRITY_ISSUE_FOUND',
  NO_INTEGRITY_ISSUE: 'NO_INTEGRITY_ISSUE',
} as const;

export const finalMessageText = _t(
  'Thank you for explaining your thought process. You can now use the Done button to go back to the assignment home page.'
);

export const retriableMessageText = _t('There was an issue submitting your answer, please try again.');

export const AssignmentType = {
  SGA: 'ASSIGNMENT',
  PGA: 'PEER_REVIEW',
} as const;

export const FeedbackStatus = {
  LIKE: 'LIKE',
  DISLIKE: 'DISLIKE',
} as const;
